import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import CheckoutPage from "@/pages/CheckoutPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import StaffDashboard from "@/pages/StaffDashboard";

function Shell({ children }) {
  return (
    <div className="App flex min-h-screen flex-col bg-background">
      <Header />
      <CartDrawer />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/menu" element={<Shell><MenuPage /></Shell>} />
            <Route path="/about" element={<Shell><About /></Shell>} />
            <Route path="/contact" element={<Shell><Contact /></Shell>} />
            <Route path="/checkout" element={<Shell><CheckoutPage /></Shell>} />
            <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
            <Route path="/payment/cancel" element={<Shell><PaymentCancel /></Shell>} />
            <Route path="/login" element={<Shell><Login /></Shell>} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/staff"
              element={
                <ProtectedRoute roles={["admin", "staff"]}>
                  <StaffDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
